import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../../app/firebase";
import { useDispatch, useSelector } from "react-redux";
import { fetchUpdates, selectUpdates, selectUpdatesLoading, selectUpdateError } from "../../../features/updates/updatesSlice";
import AdminUpdates from "./adminUpdates";

export default function AdminUpdatesContainer() {
  const dispatch = useDispatch();
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const updates = useSelector(selectUpdates);
  const loading = useSelector(selectUpdatesLoading);
  const error = useSelector(selectUpdateError);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setCheckingAdmin(true);
      setIsAdmin(false);
      if (!user) { setCheckingAdmin(false); return; }
      try {
        const token = await user.getIdTokenResult(true);
        setIsAdmin(!!token.claims.admin);
      } finally {
        setCheckingAdmin(false);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchUpdates());
    }
  }, [dispatch, isAdmin]);

  const handleRefresh = () => {
    dispatch(fetchUpdates());
  };

  if (checkingAdmin) return <div style={{ padding: 16 }}>Checking admin rights…</div>;
  if (!isAdmin) return <div style={{ padding: 16 }}>403 — Admin access only</div>;

  return (
    <AdminUpdates
      updates={updates}
      loading={loading}
      error={error}
      onRefresh={handleRefresh}
    />
  );
}

